import { render, staticRenderFns } from "./SithMesMstMaterialBasicList.vue?vue&type=template&id=fa47adf6&"
import script from "./SithMesMstMaterialBasicList.vue?vue&type=script&lang=js&"
export * from "./SithMesMstMaterialBasicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports